import { Box } from '@mui/material';
import { useEffect } from 'react';
import { useAppContext, ACTION_TYPES } from '../Context/AppContext';
import LandingHead from './Landing/LandingHead';
import LandingNav from './Landing/LandingNav';
import PricingSection from './Landing/Pricing';
import Footer from './Landing/Footer';

const PricingPage = ({ toggleDarkMode, darkMode }) => {
	const { dispatch } = useAppContext();

	useEffect(() => {
		dispatch({
			type: ACTION_TYPES.SET_PAGE_TITLE,
			payload: { pageTitle: 'Pricing' },
		});
		return () => {
			dispatch({
				type: ACTION_TYPES.SET_PAGE_TITLE,
				payload: { pageTitle: '' },
			});
		};
	}, [dispatch]);

	return (
		<Box sx={{ backgroundColor: 'background.default' }}>
			<LandingHead />
			<LandingNav toggleDarkMode={toggleDarkMode} darkMode={darkMode} />
			<Box sx={{ pt: { xs: 8, md: 10 } }}>
				<PricingSection />
			</Box>
			<Footer />
		</Box>
	);
};

export default PricingPage;
